import { action } from '@ember/object';
import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { next } from '@ember/runloop';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class DatamanagerConnectedRoute extends Route {
	@service('flow/integrations-selection-popup')
	declare flowIntegrationsSelectionPopupService: Service.Flow.IntegrationsSelectionPopup;
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;
	@service('user-settings') declare userSettingsService: Service.UserSettings;
	@service('popup') declare popupService: Service.Popup;
	@service('app-notifications') declare appNotificationService: Service.AppNotifications;
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('flow/invite-users-promo')
	declare flowInviteUsersPromoService: Service.Flow.InviteUsersPromo;
	@service('model-manager/source-types')
	declare mmSourceTypesService: Service.ModelManager.SourceTypes;

	override beforeModel(): Promise<unknown> {
		return this.mmMetricsService.requestMetrics();
	}

	override afterModel() {
		this.flowInviteUsersPromoService.checkToOpenSourcePopup();
	}

	@action
	override willTransition(_transition: PublicTransition) {
		const openSelectedConnectionsPopup =
			!this.popupService.anyPopupsOpen &&
			!this.userSettingsService.hasSeenGuidedOnboardingPopupStart && // https://app.asana.com/0/1138028810573038/1207766845535724/f
			!this.userSettingsService.hasSeenSelectedConnectionPopup &&
			this.currentUserService.isOwner &&
			this.appNotificationService.connectSelections.length >= 2;

		if (openSelectedConnectionsPopup) {
			next(() => {
				this.mmSourceTypesService.openSelectedConnectionsPopup();
			});
		}
	}
}
